module.exports = __webpack_public_path__ + "static/media/piston_case - Copy.9ae2e870.png";